module.exports = __webpack_public_path__ + "assets/img/icon-10.5bbfd313.png";